module.exports = __webpack_public_path__ + "images/emoji/scorpius.5397f902e050569e4d43.png";